export enum AlertSeverity {
  CRITICAL = 'critical',
  WARNING = 'warning',
  ERROR = 'error',
}
